export const DEFAULT_FLOW_SERIES = Object.freeze(['income', 'expense']);

// Use filtered record presence, never totals or privacy-masked values.
// This policy controls presentation only; financial data stays untouched.
export const getVisibleFlowSeries = (quickFilter, presence = {}) => {
    if (quickFilter === 'income') return ['income'];
    if (quickFilter === 'expense') return ['expense'];
    if (quickFilter === 'pending') return DEFAULT_FLOW_SERIES.filter((key) => presence[key]);
    return DEFAULT_FLOW_SERIES;
};
